<template>
  <div
    class="configurator"
    :class="{
      bg_gray: conf,
      conf_page:
        $store.state.main.selected_menu.configs.includes('configurator'),
    }"
    ref="configurator"
  >
    <div class="configurator__inner container flex j_sb">
      <picture
        v-if="!$store.state.main.selected_menu.configs.includes('configurator')"
      >
        <source
          media="(max-width: 1023px)"
          :srcset="_.get(content, 'images[0].devices.tablet')"
        />
        <source
          media="(max-width: 767px)"
          :srcset="_.get(content, 'images[0].devices.mobile')"
        />
        <img :src="_.get(content, 'images[0].devices.desktop')" />
      </picture>

      <div class="configurator__inner--right-col flex column">
        <h2 class="f-24 bold uppercase wc-lg">{{ content.title }}</h2>
        <span class="f-14 medium wc-lg">{{ content.teaser }}</span>
        <div class="configurator__filters flex" v-if="windowWidth >= 1366">
          <el-select
            v-model="industry_val"
            :placeholder="$fn.tr('Configurator industry placeholder')"
            filterable
            :popper-append-to-body="false"
            @visible-change="
              $store.state.main.stop_scroll = !$store.state.main.stop_scroll
            "
          >
            <el-option
              v-for="item in industry"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <el-select
            v-model="business_val"
            :placeholder="$fn.tr('Configurator products placeholder')"
            :popper-append-to-body="false"
            :disabled="business_status"
            @visible-change="
              $store.state.main.stop_scroll = !$store.state.main.stop_scroll
            "
          >
            <el-option
              v-for="item in business"
              :key="_.get(item, 'id')"
              :label="_.get(item, 'title')"
              :value="_.get(item, 'id')"
            >
            </el-option>
          </el-select>

          <router-link
            :to="get_configurator_url"
            class="configurator__inner--action-btn button wc-lg"
            :class="{ disabled: business_val == '' }"
            v-if="
              !$store.state.main.selected_menu.configs.includes('configurator')
            "
          >
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-16 bold uppercase f-white">{{
              $fn.tr("მაჩვენე გადაწყვეტა")
            }}</span>
          </router-link>

          <div
            @click="scroll_to()"
            class="configurator__inner--action-btn button wc-lg pointer"
            :class="{ disabled: business_val == '' }"
            v-else
          >
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-16 bold uppercase f-white">{{
              $fn.tr("მაჩვენე გადაწყვეტა")
            }}</span>
          </div>
        </div>

        <div class="configurator__filters flex column" v-else>
          <div class="configurator__filters--sm_wrapper grid">
            <el-select
              v-model="industry_val"
              :placeholder="$fn.tr('Configurator industry placeholder')"
              filterable
              :popper-append-to-body="false"
              @visible-change="
                $store.state.main.stop_scroll = !$store.state.main.stop_scroll
              "
            >
              <el-option
                v-for="item in industry"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>

            <el-select
              v-model="business_val"
              :placeholder="$fn.tr('Configurator products placeholder')"
              :popper-append-to-body="false"
              :disabled="business_status"
              @visible-change="
                $store.state.main.stop_scroll = !$store.state.main.stop_scroll
              "
            >
              <el-option
                v-for="item in business"
                :key="_.get(item, 'id')"
                :label="_.get(item, 'title')"
                :value="_.get(item, 'id')"
              >
              </el-option>
            </el-select>
          </div>

          <router-link
            :to="get_configurator_url"
            class="configurator__inner--action-btn button wc-lg"
            :class="{ disabled: business_val == '' }"
            v-if="
              !$store.state.main.selected_menu.configs.includes('configurator')
            "
          >
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-16 bold uppercase f-white">{{
              $fn.tr("მაჩვენე გადაწყვეტა")
            }}</span>
          </router-link>

          <div
            @click="scroll_to()"
            class="configurator__inner--action-btn button wc-lg pointer"
            :class="{ disabled: business_val == '' }"
            v-else
          >
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-16 bold uppercase f-white">{{
              $fn.tr("მაჩვენე გადაწყვეტა")
            }}</span>
          </div>
        </div>
        <span class="f-14 medium wc-lg configurator__teaser_2">{{
          content.teaser_2
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  data() {
    return {
      positions: "",
      industry_val: "",
      business: "",
      business_val: "",
      business_status: true,
    };
  },
  computed: {
    content() {
      return _.get(this.contentData, "data.list[0]");
    },
    industry() {
      let parents = this.$store.state.main.indx.terms.insurance;
      parents = parents.filter((parent) => parent.pid == 0);
      return parents;
    },
    industry_business() {
      let children = this.$store.state.main.indx.terms.insurance;
      children = children.filter((child) => child.pid !== 0);
      return children;
    },
    get_configurator_url() {
      let menus = this.$store.state.main.indx.menus;
      menus = menus.filter((m) => m.configs.includes("configurator"));
      return menus[0].full_url;
    },
    conf() {
      return _.get(this.contentData, "conf.conf[0]");
    },
  },
  methods: {
    get_business(industry_id) {
      this.business = this.industry_business.filter(
        (b) => b.pid == industry_id
      );
      console.log(this.business);
      this.business_status = false;
    },
    scroll_to() {
      this.$store.state.main.loco.scrollTo(
        document.querySelector("#configurator")
      );
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (
        this.$store.state.main.selected_menu.configs.includes("configurator") &&
        this.$store.state.main.selected_business
      )
        this.$store.state.main.scrollTo_conf =
          !this.$store.state.main.scrollTo_conf;
    });
  },
  watch: {
    business_val(ns, os) {
      this.$store.state.main.selected_business = ns;
      console.log(ns);
      this.$store.state.main.trigger_update =
        !this.$store.state.main.trigger_update;
    },
    industry_val(ns, os) {
      console.log(ns);
      console.log(this.business_val);

      this.$store.state.main.selected_industry = ns;
      if (this.business_val) {
        this.business_val = "";
        this.$store.state.main.selected_industry = "";
        this.$store.state.main.trigger_update =
          !this.$store.state.main.trigger_update;
        this.get_business(this.industry_val);
      } else {
        this.get_business(this.industry_val);
      }
    },
  },
};
</script>

